<!-- nlc-style Header -->
<app-page-header 
    title="Transaktionshistorie Kunde" 
    subtitle="Alle Coin-Transaktionen des Kunden im Überblick"
    icon="history" 
    variant="gradient" 
    [showBackButton]="true">
</app-page-header>


<div class="nlc-container">
    <div class="transaction-header">
        <mat-form-field appearance="fill" class="year-filter">
            <mat-label>Jahr</mat-label>
            <mat-select [(ngModel)]="selectedYear" (selectionChange)="onYearChange($event.value)">
                <mat-option *ngFor="let year of availableYears" [value]="year">
                    {{ year }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <div class="export-btn">
            <button class="nlc-button nlc-button-primary nlc-button-small"
                 (click)="exportToCSV()"
            >
                <mat-icon>download</mat-icon>
                Exportieren als CSV
            </button>
        </div>
    </div>
    <div class="nlc-transaction-history-table-card nlc-card">
        <table class="nlc-transaction-history-table">
            <thead>
                <tr class="nlc-table-header-row">
                    <th>Kunde</th>
                    <th>Datum</th>
                    <th>Grund</th>
                    <th>Auftragsnummer</th>
                    <th>Betrag</th>
                    <th>Vergeben von</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let tx of filteredTransactions$ | async" class="nlc-table-row">
                    <td>{{ tx.customer?.userDetails?.firstName }} {{
                        tx.customer?.userDetails?.lastName }}</td>
                    <td>{{ tx.createdDate | date:'dd.MM.yyyy' }}</td>
                    <td>{{ tx.reason?.reasonText }}</td>
                    <td>{{ tx.reflexOrderNo }}</td>
                    <td>{{ tx.amount }}</td>
                    <td>{{ tx.reason?.reasonText?.includes('Generiert') ? 'NicLen GmbH' :
                        (tx.grantedBy ? (tx.grantedBy.firstName + ' ' + tx.grantedBy.lastName) : '-') }}</td>
                </tr>
                <!-- Total Row -->
                <tr class="nlc-table-row total-row" *ngIf="(filteredTransactions$ | async)?.length">
                    <td colspan="4"><strong>Summe {{ selectedYear }}</strong></td>
                    <td style="color: #4a90e2;"><strong>{{ totalCoins$ | async }}</strong></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="(filteredTransactions$ | async)?.length === 0" class="empty-state">
            Keine Transaktionen für {{ selectedYear }} gefunden.
        </div>
    </div>
</div>